/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_AffectedInputs */

const tr_landing_pricerules_mock_bot_affected = /** @type {(inputs: Landing_Pricerules_Mock_Bot_AffectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 ürün etkileniyor. Onaylıyor musunuz?`)
};

const en_landing_pricerules_mock_bot_affected = /** @type {(inputs: Landing_Pricerules_Mock_Bot_AffectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 products affected. Approve?`)
};

const de_landing_pricerules_mock_bot_affected = /** @type {(inputs: Landing_Pricerules_Mock_Bot_AffectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 Produkte betroffen. Freigeben?`)
};

const ru_landing_pricerules_mock_bot_affected = /** @type {(inputs: Landing_Pricerules_Mock_Bot_AffectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затронуто 27 товаров. Подтвердить?`)
};

/**
* | output |
* | --- |
* | "27 products affected. Approve?" |
*
* @param {Landing_Pricerules_Mock_Bot_AffectedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_affected = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_AffectedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_AffectedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_affected(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_affected(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_affected(inputs)
	return tr_landing_pricerules_mock_bot_affected(inputs)
});